export const formatFootnote = (text: string, index: number) => {
  return text.trim().match(/^[0-9]+/g) || text.trim()[0] === "^"
    ? text
    : `^${index}^ ${text}`;
};
